import { SVGLoader } from 'three/examples/jsm/Addons.js'

import {
    ExtrudeGeometry,
    ExtrudeGeometryOptions,
    Group,
    Mesh,
    MeshStandardMaterial,
} from 'three'

export function iconFactory(
    svg: string,
    mapMesh?: (mesh: Mesh, position: number) => void | boolean,
    options: ExtrudeGeometryOptions = { depth: 20 },
): Group {
    const result = new SVGLoader().parse(svg)

    const meshes = result.paths.map((shape, i) => {
        const geometry = new ExtrudeGeometry(
            SVGLoader.createShapes(shape),
            options,
        )

        const material = new MeshStandardMaterial({
            color: shape.color,
        })

        const mesh = new Mesh(geometry, material)

        if (mapMesh) {
            const shouldNotReturn = mapMesh(mesh, i)
            if (shouldNotReturn) return null
        }

        return mesh
    })

    const group = new Group()

    for (const mesh of meshes) {
        if (mesh) group.add(mesh)
    }

    group.rotateX(Math.PI)

    return group
}
